(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-frequent-bought"] && !Shopify.designMode) return;
  try {
    

function recomProduct() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-bought');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
        new Swiper('.productboughtSlider .swiper-container', {
            
          nextButton: '.productboughtSlider .product_slide_nav .swiper-button-next',
          prevButton: '.productboughtSlider .product_slide_nav .swiper-button-prev',
          slidesPerView: 4,
          allowTouchMove: true,
          centeredSlides: false,
          spaceBetween: 30,
          // threshold: 75,
          preventClicks: false,
          paginationClickable: true,
          loop: false,
          breakpoints: {
            767: {
              slidesPerView: 3,
              loop:false
            },
            500: {
                slidesPerView: 2,
                loop:false,
                spaceBetween: 0,
            }
        }
         
      })


      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-bought');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);


}


recomProduct();



  } catch(e) { console.error(e); }
})();
})();
